/* eslint-disable react/no-danger */
import { Skeleton } from "@mui/material";

const GKEditorViewer = ({
  content,
  loading,
  id,
}: {
  loading?: boolean;
  content: string;
  id?: string;
}) => {
  return loading ? (
    <Skeleton variant="text" sx={{ width: "100%" }} />
  ) : (
    <div
      id={id}
      className="ck"
      style={{
        textAlign: "justify",
      }}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};

export default GKEditorViewer;
